(() => {
  if (window.IAMKlaviyoSubscribe?.initialized) {
    window.IAMKlaviyoSubscribe.initAllKlaviyoForms?.();
    return;
  }

  const KLAVIYO_TIMEOUT_MS = 15000;
  const IAM_KLAVIYO_ENDPOINT = 'https://subscribe.houseofiam.com/subscribe';
  const initialized = new WeakSet();

  function initAllKlaviyoForms(root = document) {
    root.querySelectorAll('[data-iam-klaviyo-form]').forEach(initKlaviyoForm);
  }

  function revealGuideSignupElement(target, trigger) {
    if (!target) return;

    target.hidden = false;
    target.classList.add('is-revealed');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      if (!trigger.matches('[data-iam-pdp-guide-toggle], .iam-pdp-guide-link')) {
        trigger.hidden = true;
        trigger.style.display = 'none';
      }
    }

    const email = target.querySelector('[data-iam-klaviyo-email]');
    if (email && !email.disabled) {
      window.requestAnimationFrame(() => email.focus({ preventScroll: true }));
    }
  }

  function revealGuideSignup(targetSelector, trigger) {
    if (!targetSelector) return;

    revealGuideSignupElement(document.querySelector(targetSelector), trigger);
  }

  function initKlaviyoForm(form) {
    if (!form || initialized.has(form)) return;
    initialized.add(form);

    const companyId = form.dataset.companyId?.trim();
    const source = form.dataset.source?.trim() || 'Website signup';
    const sourceListOverrides = {
      'Homepage stay close': 'UgP77k',
      'Website welcome slide-up': 'YzUr8F',
    };
    const listId = sourceListOverrides[source] || form.dataset.listId?.trim();
    const successMessage = form.dataset.successMessage?.trim() || 'Thanks — you’re in.';
    const email = form.querySelector('[data-iam-klaviyo-email]');
    const status = form.querySelector('[data-iam-klaviyo-status]');
    const success = form.querySelector('[data-iam-klaviyo-success]');
    const submitButton = form.querySelector('[type="submit"]');

    if (!companyId || !listId || !email || !status) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const value = email.value.trim();
      status.hidden = false;
      status.classList.remove('is-success', 'is-error');

      if (!isValidEmailAddress(value) || !email.checkValidity()) {
        status.textContent = 'Enter a valid email address.';
        status.classList.add('is-error');
        email.focus();
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.dataset.originalText = submitButton.dataset.originalText || submitButton.textContent;
        submitButton.textContent = 'Submitting…';
      }

      status.textContent = 'Submitting…';

      try {
        await subscribeEmailToKlaviyo({ email: value, companyId, listId, customSource: source });

        if (success) {
          status.textContent = '';
          status.hidden = true;
        } else {
          status.textContent = successMessage;
        }

        status.classList.add('is-success');
        form.classList.add('is-success');
        email.disabled = true;

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.hidden = Boolean(success);
          submitButton.textContent = successMessage;
        }

        if (success) success.hidden = false;
      } catch (error) {
        console.error('Klaviyo form signup failed.', error);
        status.textContent = "We couldn't submit your email right now. Please try again.";
        status.classList.add('is-error');

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = submitButton.dataset.originalText || 'Submit';
        }
      }
    });
  }

  function isValidEmailAddress(value) {
    // Browser email validation allows single-label domains like “name@c”,
    // but Klaviyo rejects them. Require a normal dotted domain so users see
    // the validation message before submission instead of a generic API error.
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  async function subscribeEmailToKlaviyo({ email, companyId, listId, customSource }) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), KLAVIYO_TIMEOUT_MS);

    let response;

    try {
      response = await fetch(IAM_KLAVIYO_ENDPOINT, {
        method: 'POST',
        signal: controller.signal,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          email,
          companyId,
          listId,
          customSource,
        }),
      });
    } catch (error) {
      if (error?.name === 'AbortError') {
        throw new Error('Klaviyo request timed out.');
      }

      throw error;
    } finally {
      window.clearTimeout(timeout);
    }

    if (response.status === 202) return;

    let detail = 'Subscription failed.';

    try {
      const payload = await response.json();
      detail = payload?.errors?.[0]?.detail || detail;
    } catch {
      // Ignore malformed error responses and use the default message.
    }

    throw new Error(detail);
  }

  window.IAMKlaviyoSubscribe = {
    initialized: true,
    initAllKlaviyoForms,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllKlaviyoForms());
  } else {
    initAllKlaviyoForms();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllKlaviyoForms(event.target);
  });

  document.addEventListener('click', (event) => {
    const guideTrigger = event.target.closest('[data-iam-guide-toggle]');
    if (guideTrigger) {
      event.preventDefault();
      revealGuideSignup(guideTrigger.getAttribute('data-iam-guide-toggle'), guideTrigger);
      return;
    }

    const pdpGuideTrigger = event.target.closest('[data-iam-pdp-guide-toggle], [data-iam-pdp-guide-scope] a[href="#microdosing-starter-guide-signup"], .iam-accordion-section a[href="#microdosing-starter-guide-signup"]');
    if (!pdpGuideTrigger) return;

    event.preventDefault();
    const scope = pdpGuideTrigger.closest('[data-iam-pdp-guide-scope]') || pdpGuideTrigger.closest('.shopify-section') || document;
    revealGuideSignupElement(scope.querySelector('[data-iam-pdp-guide-form]'), pdpGuideTrigger);
  });
})();
